import React from 'react';
import { useAuth } from '../../utils/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaAccusoft, FaUserCircle } from 'react-icons/fa';

const TopBar = () => {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="bg-gray-800 m-2 mb-8 text-white fixed rounded-2xl top-0 mx-2 left-64 right-0 z-10 flex justify-between items-center px-4 py-2">
      <div className="flex items-center space-x-4">
        <FaAccusoft className="text-2xl" />
        <div className="text-xl font-bold">Technomedia Solutions p Ltd</div>
      </div>
      <div className="flex items-center space-x-4">
        <FaUserCircle className="text-2xl" />
        <span>{auth.employeeName} ({auth.role})</span>
        <button onClick={handleLogout} className="px-4 py-2 bg-red-500 rounded hover:bg-red-600">Logout</button>
      </div>
    </div>
  );
};

export default TopBar;
